<template>
    <div class="operator-wrapper" @click="tableClickAction">
        <div class="operator-button" v-for="item in items" :key="item.id" :attr-id="item.id">{{ item.label }}</div>
    </div>
</template>

<script>
import accountEditModal from "./accountEditModal";

/* eslint-disable */
export default {
    name: "OperateColumn",
    props: ["data", "row"],
    data() {
        return {
            isShowPopup: false
        };
    },
    computed: {
        labels() {
            return {
                edit: this.$t("zhiji.common.edit"),
                disable: this.$t("zhiji.common.disable"),
                delete: this.$t("zhiji.common.delete"),
                enable: this.$t("zhiji.common.enable")
            };
        },
        items() {
            return this.data.map((item) => {
                return {
                    label: this.labels[item],
                    id: item
                };
            });
        }
    },
    methods: {
        tableClickAction(event) {
            const target = event.target;
            const itemId = target.getAttribute("attr-id");

            const handlers = {
                disable: this.disableAction,
                delete: this.deleteAction,
                edit: this.editorAction,
                enable: this.enableAction
            };

            handlers[itemId].call(this, itemId);
        },
        editorAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: accountEditModal,
                data: this.row,
            });
        },
        deleteAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.personnel.accountManage.deleteAccountTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.deleteAccount();
                    }
                }
            });
        },
        deleteAccount() {
            this.$store.dispatch("zhiji/deleteAccountData", {
                accountId: this.row.rowId,
            });
        },
        disableAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.personnel.accountManage.disabledAccountTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/updateAccountStatus", {
                            accountId: this.row.rowId,
                            status: 0,
                        });
                    }
                }
            });
        },
        enableAction() {
            this.$store.dispatch("zhiji/updateAccountStatus", {
                accountId: this.row.rowId,
                status: 1,
            });
        }
    }
};
</script>

<style lang="less" scoped>
.operator-wrapper {
    white-space: nowrap;
    .operator-button {
        display: inline-block;
        font-size: 12px;
        margin-right: 8px;
        border: 1px solid #d8e4f0;
        padding: 2px 8px;
        background: #fff;
        border-radius: 4px;

        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
